module.exports = __webpack_public_path__ + "static/media/arrow-neon.723a2c19.svg";